import { render, staticRenderFns } from "./MapSidebarSettings.vue?vue&type=template&id=827f6d16&scoped=true&"
import script from "./MapSidebarSettings.vue?vue&type=script&lang=js&"
export * from "./MapSidebarSettings.vue?vue&type=script&lang=js&"
import style0 from "./MapSidebarSettings.vue?vue&type=style&index=0&id=827f6d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827f6d16",
  null
  
)

export default component.exports